import React from 'react';
import _get from 'lodash/get';
import styles from './index.module.scss';

import { UiKit } from 'components';

export default function Setup({
  title = '',
  caption = '',
  value = {},
  onChange = () => {},
  isDisabled = false
}) {
  const isEnabled = _get(value, 'isEnabled', false);

  return (
    <UiKit.Grid templateColumns="auto 1fr" gap="16">
      <UiKit.Toggle
        isActive={isEnabled}
        onChange={value => onChange({ isEnabled: value }, !value)}
        className={styles.toggle}
        disabled={isDisabled}
      />
      <UiKit.Grid templateColumns="1fr" gap="4">
        <div className={styles.title}>{title}</div>
        <div className={styles.caption}>{caption}</div>
      </UiKit.Grid>
    </UiKit.Grid>
  );
}
